const codeHostingDomains = [
  '*.github.com',
  '*.githubusercontent.com',
  'atomicredteam.io',
  'nmap.org',
  '*.github.io',
  '7-zip.org',
  'download.*.com',
  'gofrp.com',
  'sliver.sh',
  'poweradmin.com',
  'winpeas.com',
  '*.gitlab.com',
] as const

/**
 * Checks if a given link is outside of the Galvanick portal domain
 */
export function isExternalLink(href: string): URL | null {
  let parsed: URL
  try {
    parsed = new URL(href, window.location.href)
  } catch {
    return null
  }
  if (parsed.origin === window.location.origin) return null
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null
  return parsed
}

/**
 * Checks if given link has a domain that matches a pattern (can use explicit domains like nmap.org or additional subdomain matching)
 */
export function domainMatchesPattern(hostname: string, pattern: string): boolean {
  const re = new RegExp(
    '^' + pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '[^.]+') + '$',
  )
  if (re.test(hostname)) return true
  if (pattern.startsWith('*.') && hostname === pattern.slice(2)) return true
  return false
}

export function isCodeHostingDomain(hostname: string): boolean {
  return codeHostingDomains.some((d) => domainMatchesPattern(hostname, d))
}